import React, { useEffect, useState } from "react";

const PersonaRegistrationsForm = ({ onCreatePersona }) => {
  const [personaName, setPersonaName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const personaRegistrationEndpoint = `${process.env.REACT_APP_SERVER_URL}/aipd/persona-administration/persona-registration`;

  const passtoken =
    !localStorage.getItem("access-token-storage") ||
    localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const showToast = (message, type = "success") => {
    setToastState({
      show: true,
      type,
      message,
    });
  };

  useEffect(() => {
    if (!toastState.show) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setToastState((prevState) => ({ ...prevState, show: false }));
    }, 3000);

    return () => clearTimeout(timer);
  }, [toastState.show]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedName = personaName.trim();
    if (!trimmedName) {
      showToast("Persona Name cannot be empty.", "danger");
      return;
    }

    setIsSubmitting(true);

    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (passtoken) {
        headers["oidc-token"] = passtoken;
      }

      const response = await fetch(personaRegistrationEndpoint, {
        method: "POST",
        headers,
        body: JSON.stringify({
          persona_name: trimmedName,
        }),
      });

      const responseJson = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(responseJson?.message || "Failed to create persona.");
      }

      if (onCreatePersona) {
        onCreatePersona(trimmedName);
      }
      setPersonaName("");
      showToast("Persona created successfully.", "success");
    } catch (error) {
      showToast(error?.message || "Unable to create persona at the moment.", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rr-wrap container-fluid pb-4">
      {toastState.show && (
        <div
          style={{
            position: "fixed",
            top: "16px",
            right: "16px",
            zIndex: 99999,
            minWidth: "320px",
            maxWidth: "420px",
          }}
        >
          <div className={`alert alert-${toastState.type} shadow-sm mb-0`} role="alert">
            {toastState.message}
          </div>
        </div>
      )}

      <div className="rr-card">
        <div className="rr-cardHeader">
          <p className="rr-kicker">Persona Intake</p>
          <h5 className="rr-title">Persona Registration</h5>
          <p className="rr-subtitle">
            Create a new persona by entering the persona name.
          </p>
        </div>

        <div className="rr-content">
          <div className="rr-sidePanel">
            <div className="rr-sideBadge">Info</div>
            <ul className="rr-checklist">
              <li>Use a clear and unique persona name.</li>
              <li>Persona names are case-insensitive for duplicates.</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3 rr-formGrid">
              <div className="col-12">
                <label htmlFor="personaName" className="form-label rr-label">
                  Persona Name
                  <span className="text-danger ms-1">*</span>
                </label>
                <input
                  id="personaName"
                  name="personaName"
                  type="text"
                  className="form-control rr-input"
                  placeholder="Enter persona name"
                  value={personaName}
                  onChange={(event) => setPersonaName(event.target.value)}
                  disabled={isSubmitting}
                  required
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-4 rr-actions">
              <button type="submit" className="btn rr-btnPrimary" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PersonaRegistrationsForm;
